import {useMemo} from 'react';

import {ApiForecastThresholdAlertConfig} from 'src/lib/api/alert_configs';
import {RateVolumeMode, Source, isCumulativeMode} from 'src/lib/api/series';
import {HYDROFORECAST_ALERT_TYPE_THRESHOLD} from 'src/lib/constants';

import {useAlertConfigs} from './useHydroforecastAlertConfig';

export function useThresholdLinesForSite(
  siteId: string,
  currentUserId: string | undefined,
  rateVolumeMode: RateVolumeMode
): ApiForecastThresholdAlertConfig[] {
  const {alertConfigs} = useAlertConfigs();

  return useMemo(() => {
    if (!alertConfigs || !currentUserId) return [];

    return alertConfigs.filter((config): config is ApiForecastThresholdAlertConfig => {
      if (config.alertType !== HYDROFORECAST_ALERT_TYPE_THRESHOLD) return false;

      const props = config.properties;
      const configMode = props.rateVolumeMode || 'rate';

      if (!props.showOnPlot) return false;
      if (!config.siteIds.includes(siteId)) return false;
      if (props.showOnPlot === 'self' && config.createdBy !== currentUserId) return false;
      if (isCumulativeMode(rateVolumeMode)) return false;
      if (props.source !== Source.HydroForecastShortTerm) return false;

      return rateVolumeMode === 'level' ? configMode === 'level' : configMode !== 'level';
    });
  }, [alertConfigs, siteId, currentUserId, rateVolumeMode]);
}
